<template>
  <UCard 
    :ui="{ 
      body: { 
        padding: 'p-4',
        base: 'relative cursor-pointer transition-transform hover:scale-105' 
      } 
    }"
    :class="{
      'bg-green-100 dark:bg-green-950/30': status === 'done'
    }"
    @click="onClick"
  >
    <div class="flex items-center gap-4">
      <UIcon 
        :name="icon" 
        class="flex-shrink-0 w-8 h-8"
        :class="{
          'text-gray-400': status === 'not_relevant',
          'text-primary-500': status === 'in_progress',
          'text-green-500': status === 'done'
        }"
      />
      <div class="flex-grow">
        <h3 class="text-lg font-semibold">{{ title }}</h3>
        <p class="text-sm text-gray-600 dark:text-gray-400">{{ description }}</p>
      </div>
      <UIcon 
        :name="statusIcon" 
        class="flex-shrink-0 w-6 h-6"
        :class="statusIconClass"
      />
    </div>
  </UCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from '#imports'
import type { WizardStatus } from '../stores/startWizardStore'

const props = defineProps<{
  title: string
  description: string
  icon: string
  navigateTo: string
  status: WizardStatus
  doneAt?: Date
}>()

const router = useRouter()

const statusIcon = computed(() => {
  switch (props.status) {
    case 'done': return 'i-heroicons-check-circle'
    case 'not_relevant': return 'i-heroicons-x-circle'
    default: return 'i-heroicons-arrow-right'
  }
})

const statusIconClass = computed(() => {
  switch (props.status) {
    case 'done': return 'text-green-500'
    case 'not_relevant': return 'text-gray-400'
    default: return 'text-primary-500'
  }
})

function onClick() {
  router.push(props.navigateTo)
}
</script> 